/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_SavedInputs */



/**
* | output |
* | --- |
* | "Settings have been saved successfully." |
*
* @param {Options_Cli_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_saved = /** @type {((inputs?: Options_Cli_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les paramètres ont été enregistrés avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Einstellungen wurden erfolgreich gespeichert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le impostazioni sono state salvate correttamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки успешно сохранены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La configuración se ha guardado correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置已成功保存。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定が正常に保存されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स सफलतापूर्वक सहेज ली गई हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As configurações foram salvas com sucesso.")
	return /** @type {LocalizedString} */ ("Settings have been saved successfully.")
});